import { Calendar } from "lucide-react";
import { gluceraCalendarIcon, gluceraCalendarTrigger } from "../../utils/homeBlueTheme";
import { cn } from "../../lib/utils";

export interface GluceraDateCalendarProps {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  currentMonth?: Date;
  onCurrentMonthChange?: (month: Date) => void;
  selectedDate: string;
  onDateSelect: (dateString: string) => void;
  /** Optional extra class on the trigger button */
  triggerClassName?: string;
}

const GluceraDateCalendar = ({
  selectedDate,
  onDateSelect,
  triggerClassName,
}: GluceraDateCalendarProps) => {
  return (
    <div className="relative inline-block">
      {/* Styled icon button */}
      <button
        type="button"
        className={cn(gluceraCalendarTrigger, triggerClassName)}
        aria-label="Choose date"
      >
        <Calendar className={gluceraCalendarIcon} />
      </button>

      {/* Native date picker input overlay for perfect mobile UX */}
      <input
        type="date"
        value={selectedDate}
        max={new Date().toISOString().split("T")[0]}
        onChange={(e) => {
          if (e.target.value) {
            onDateSelect(e.target.value);
          }
        }}
        onClick={(e) => {
          try {
            e.currentTarget.showPicker();
          } catch (err) {
            console.warn("showPicker not supported", err);
          }
        }}
        className="absolute inset-0 z-10 h-full w-full cursor-pointer opacity-0"
      />
    </div>
  );
};

export default GluceraDateCalendar;
